import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PageLoading from '@/components/PageLoading'

const Home = React.lazy(() => import("@/pages/home"))
const CatalogPage = React.lazy(() => import("@/pages/catalog"))
const BrandsPage = React.lazy(() => import("@/pages/brands"))
const BrandPage = React.lazy(() => import("@/pages/brand"))
const ArrivalsPage = React.lazy(() => import("@/pages/arrivals"))
const ArrivalDetailPage = React.lazy(() => import("@/pages/arrival-detail"))
const ProductPage = React.lazy(() => import("@/pages/product"))
const VideoReviewsPage = React.lazy(() => import("@/pages/video-reviews"))
const VideoReviewDetailPage = React.lazy(() => import("@/pages/video-review-detail"))
const ShowcasePage = React.lazy(() => import("@/pages/showcase"))
const LiteProductsListPage = React.lazy(() => import('@/pages/lite-products-list'))
const LiteLoginPage = React.lazy(() => import('@/pages/lite-login'))
const CartPage = React.lazy(() => import("@/pages/cart"))
const FavoritesPage = React.lazy(() => import("@/pages/favorites"))
const LoginPage = React.lazy(() => import("@/pages/login"))
const RegisterPage = React.lazy(() => import("@/pages/register"))
const ProfilePage = React.lazy(() => import("@/pages/profile"))
const OrderDetailPage = React.lazy(() => import("@/pages/profile/OrderDetailPage"))
const AuthCallbackPage = React.lazy(() => import("@/pages/auth-callback"))
const OrderPaymentPage = React.lazy(() => import("@/pages/order-payment"))
const OrderSuccessPage = React.lazy(() => import("@/pages/order-success"))
const ComparePage = React.lazy(() => import("@/pages/compare"))
const StorePage = React.lazy(() => import("@/pages/store"))
const AnalyzerPage = React.lazy(() => import("@/pages/analyzer"))
const LegalPage = React.lazy(() => import("@/pages/legal"))
const NotFound = React.lazy(() => import("@/pages/NotFound"))

const routes = [
  { path: "/", element: <Home /> },
  { path: "/catalog", element: <CatalogPage /> },
  { path: "/brands", element: <BrandsPage /> },
  { path: "/brands/:slug", element: <BrandPage /> },
  { path: "/arrivals", element: <ArrivalsPage /> },
  { path: "/arrivals/:slug", element: <ArrivalDetailPage /> },
  { path: "/postupleniya", element: <ArrivalsPage /> },
  { path: "/postupleniya/:slug", element: <ArrivalDetailPage /> },
  { path: "/video-reviews", element: <VideoReviewsPage /> },
  { path: "/video-reviews/:slug", element: <VideoReviewDetailPage /> },
  { path: "/showcases/:slug", element: <ShowcasePage /> },
  { path: "/lite/products/list", element: <LiteProductsListPage /> },
  { path: "/lite/login", element: <LiteLoginPage /> },
  { path: "/products/:id", element: <ProductPage /> },
  { path: "/cart", element: <CartPage /> },
  { path: "/favorites", element: <FavoritesPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/register", element: <RegisterPage /> },
  { path: "/profile", element: <ProfilePage /> },
  { path: "/profile/orders/:orderId", element: <OrderDetailPage /> },
  { path: "/auth-callback", element: <AuthCallbackPage /> },
  { path: "/order/:orderId/pay", element: <OrderPaymentPage /> },
  { path: "/order/:orderId/success", element: <OrderSuccessPage /> },
  { path: "/compare", element: <ComparePage /> },
  { path: "/analyzer", element: <AnalyzerPage /> },
  { path: "/stores/:id", element: <StorePage /> },
  { path: "/legal/:slug", element: <LegalPage /> },
  { path: "*", element: <NotFound /> },
]

const RouterProvider = () => {
  return (
    <Routes>
      {routes.map(({ path, element }) => (
        <Route
          key={path}
          path={path}
          caseSensitive
          element={
            <React.Suspense fallback={<PageLoading />}>
              {element}
            </React.Suspense>
          }
        />
      ))}
    </Routes>
  )
}

export default RouterProvider
